const axios = require('axios')
import apiUrl from '../../api.config';

const PATIENT_API_URL = `${apiUrl}patient`;

const PatientService = {
    add(patientData) {
        return axios.post(PATIENT_API_URL + '/add', patientData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    getByCategory(categoryId) {
        return axios.get(PATIENT_API_URL + '/getByCategory/' + categoryId, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    update(patientData) {
        return axios.post(PATIENT_API_URL + '/update', patientData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    getPatientByStudent(patientId) {
        return axios.get(PATIENT_API_URL + '/getPatientByStudent/' + patientId, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    getPracticePatientWithGroupByStudent() {
        return axios.get(PATIENT_API_URL + '/getPracticePatientWithGroupByStudent', {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    updatePatientStatus(patientId, isActive) {
        return axios.post(PATIENT_API_URL + '/updatePatientStatus', { patientId, isActive }, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    deleteUploadedImageSingle(patientId, imageType, image) {
        return axios.post(PATIENT_API_URL + '/deleteUploadedImageSingle', { patientId, imageType, image }, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    delete(patientId) {
        return axios.delete(PATIENT_API_URL + '/delete/' + patientId, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    getPatientSortByTagCategoryTopic() {
        return axios.get(PATIENT_API_URL + '/getPatientSortByTagCategoryTopic', {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
}

export default PatientService;